import { clientLogger } from "@ka-astro/utils";
import { useState, useEffect } from "react";
import type { JSX } from "react/jsx-runtime";
import { FULL_SHARED_STATIC_PATH } from "../../constants";

function UnsupportedBrowserWarning(): JSX.Element | null {
  const [isSupported, setIsSupported] = useState(true);
  useEffect(() => {
    function supportsClassStaticInitialization(): boolean {
      try {
        return eval(`
            class Test {
                static supported = false;
                static {
                    this.supported = true;
                }
            }
            Test.supported;
        `);
      } catch (_error) {
        return false;
      }
    }

    function isES2022Supported(): boolean {
      const hasOwnSupported = typeof Object.hasOwn === "function";
      const arrayAtSupported = typeof Array.prototype.at === "function";
      const classStaticInitializationSupported =
        supportsClassStaticInitialization();

      let errorCauseSupported = false;
      try {
        const errorWithCause = new Error("Test Error", { cause: "Test Cause" });
        errorCauseSupported = errorWithCause.cause === "Test Cause";
      } catch (error) {
        clientLogger.error(error);
        errorCauseSupported = false;
      }
      return (
        hasOwnSupported &&
        arrayAtSupported &&
        classStaticInitializationSupported &&
        errorCauseSupported
      );
    }

    const browserSupported = isES2022Supported();
    setIsSupported(browserSupported);
  }, []);

  if (isSupported) {
    return null;
  }

  return (
    <div>
      {/* <%-- we use a div instead of an h tag here to not interfer with SEO --%> */}
      <header className="rounded-t-medium border border-critical bg-critical px-small py-xsmall text-onCritical">
        <div>Bitte aktualisiere deinen Browser</div>
      </header>
      <div className="flex items-center rounded-b-medium border border-critical bg-surface p-small">
        <img
          src={`/${FULL_SHARED_STATIC_PATH}/illustrations/connection-issue.svg`}
          alt=""
          width="79"
          height="79"
        />
        <p className="ml-xlarge">
          Viele Deals wurden auf Kleinanzeigen gemacht, seit dein Browser das
          Licht der Welt erblickt hat. Um weiterhin alle Funktionen einwandfrei
          nutzen zu können, solltest du ihn aktualisieren. Wir empfehlen{" "}
          <a
            href="https://www.google.com/intl/de/chrome/"
            className="text-interactive underline"
            target="_blank"
            rel="nofollow noreferrer"
          >
            Google Chrome
          </a>
          ,{" "}
          <a
            href="https://www.mozilla.org/de/firefox/new/"
            className="text-interactive underline"
            target="_blank"
            rel="nofollow noreferrer"
          >
            Mozilla Firefox
          </a>
          ,{" "}
          <a
            href="https://www.microsoft.com/de-de/edge"
            className="text-interactive underline"
            target="_blank"
            rel="nofollow noreferrer"
          >
            Microsoft Edge
          </a>{" "}
          oder{" "}
          <a
            className="text-interactive underline"
            target="_blank"
            rel="nofollow noreferrer"
            href="https://support.apple.com/de-de/HT204416"
          >
            Safari
          </a>
          , falls du macOS benutzt.
        </p>
      </div>
    </div>
  );
}

export default UnsupportedBrowserWarning;
